<template>
  <splide
    :options="splide_options"
    @splide:mounted="onMounted"
    class="home-hero__carousel-splide"
    ref="splide"
  >
    <template v-for="(option,o) in payload" :key="o">
      <splide-slide v-if="option.icon">
        <a :href="option.link">
          <img :src="option.icon" :alt="option.title">
          <p v-html="option.label"></p>
        </a>
      </splide-slide>
    </template>
  </splide>
</template>

<script>

import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import EscIcon from '@/main/components/icons/EscIcon';

export default {
  components: {
    Splide,
    SplideSlide,
    EscIcon
  },

  props: {
    payload: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
			splide_options: {
        type: 'slide', // slide/loop/fade
        autoplay: false,
        rewind: false,
        rewindSpeed: 1000,
        interval: 5000,
        width: '100%',
        gap: '1rem',
        arrows: true,
        pagination: false,
        perPage: 4,
        padding: {left: '1rem', right:'1rem'},
        breakpoints: {
          1024: {
            perPage: 3
          }
        }
      }
    }
  },

  methods: {
    onMounted(splide) {
      console.log('Splide mounted:', splide);
    }
  }
}

</script>
